import React from "react"

export const H1 = ({className="text-black", children}: {className?:string, children: React.ReactNode}) => {
    return (
        <h1 className={`text-4xl font-bold ${className ?? ''}`}>{children}</h1>
    )
}